(function () {
    'use strict';

    Components.FooterComponent = {
        bindings: {
            isVisible: '=',
            title: '@',
            text: '@',

            primaryButtonText: '@',
            primaryButtonAction: '&',
            primaryButtonAnalyticsEventName: '@',
            primaryButtonAnalyticsEventProperties: '@',

            secondaryButtonText: '@',
            secondaryButtonAction: '&',
            secondaryButtonAnalyticsEventName: '@',
            secondaryButtonAnalyticsEventProperties: '@'
        },

        // @ngInject
        controller: function FooterComponentControllerCtor() {

        },
        name: 'hbFooter',
        templateUrl: 'angular/app/modules/common/ui_components/hb-footer/hb_footer.html',
    };

}());